import { Container } from "@mui/material";
import { wrapperFooter } from "./footer.style";
import Grid from "@mui/material/Grid2";

const Footer = () => {
  return (
    <Grid sx={wrapperFooter}>
      <Container>
        <hr />
        <Grid py={2} sx={{ textAlign: "center" }}>
          © 2026, All Rights Reserved
        </Grid>
      </Container>
    </Grid>
  );
};

export default Footer;
